module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M48 448l416-192L48 64v149.333L346 256 48 298.667z\"></path></svg>"